import styled from 'styled-components'

export const RowStyles = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
